import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ['type', 'value']

  connect () {
    this.setType()
  }

  setType () {
    const typeSelect = this.typeTarget.querySelector('select')
    const target = this.valueTargets.find(
      element => element.attributes['data-type'].value === typeSelect.value
    )

    this.valueTargets.map(
      element => {
        element.setAttribute('style', 'display: none')
        element.querySelector('select').setAttribute('disabled', 'disabled')
      }
    )

    target?.removeAttribute('style')
    // A locked type locks its value too: the address owner is readonly.
    target?.querySelector('select').toggleAttribute('disabled', typeSelect.disabled)
  }
}
